export const daysOfWeek = [
  { label: "Sat", value: 6 },
  { label: "Sun", value: 0 },
  { label: "Mon", value: 1 },
  { label: "Tue", value: 2 },
  { label: "Wed", value: 3 },
  { label: "Thu", value: 4 },
  { label: "Fri", value: 5 },
];

export const SERVICE_STATUS = {
  1: { label: "Scheduled", color: "info" },
  2: { label: "Completed", color: "success" },
  3: { label: "Cancelled", color: "error" },
  4: { label: "No Show", color: "secondary" },
};

export const TimePartition = {
  Night: 1,
  Morning: 2,
  Evening: 3,
};
